// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-037e877e] .van-nav-bar__left .tit-left {\n  color: #fff;\n}\n[data-v-037e877e] .van-nav-bar__right .tit-right {\n  color: #fff;\n}", ""]);
// Exports
module.exports = exports;
